import { useState, useEffect } from "react";
import { ImageOff } from "lucide-react";
import { mediaUrl } from "../lib/api";

// Avatar with graceful fallback to initials when the image is missing/404s.
export function Avatar({ src, name, size = "h-8 w-8", rounded = "rounded-lg", textClass = "text-xs", className = "", testid }) {
    const [err, setErr] = useState(false);
    useEffect(() => setErr(false), [src]);
    const initials = (name || "?").trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase() || "?";
    if (src && !err) {
        return (
            <img
                data-testid={testid}
                src={mediaUrl(src)}
                alt={name || "avatar"}
                onError={() => setErr(true)}
                className={`${size} ${rounded} object-cover border border-white/10 ${className}`}
            />
        );
    }
    return (
        <span data-testid={testid} className={`${size} ${rounded} flex items-center justify-center bg-gradient-to-br from-orange-500 to-amber-500 font-black text-zinc-950 ${textClass} ${className}`}>
            {initials}
        </span>
    );
}

// Job/content image with a neutral placeholder fallback.
export function ImageWithFallback({ src, alt, className = "", testid }) {
    const [err, setErr] = useState(false);
    useEffect(() => setErr(false), [src]);
    if (!src || err) {
        return (
            <div data-testid={testid} className={`flex items-center justify-center bg-zinc-900 text-zinc-600 ${className}`}>
                <ImageOff className="h-6 w-6" />
            </div>
        );
    }
    return <img data-testid={testid} src={mediaUrl(src)} alt={alt} onError={() => setErr(true)} className={className} />;
}
